<template>
  <div class="cranePage">
    <div class="aBox1">
      <img
        class="ab1Img"
        src="http://cdn.xiyundata.com/crane_index/crane01.jpg"
        alt=""
      />
      <img
        class="ab1Img2"
        src="http://cdn.xiyundata.com/crane_index/crane02.jpg"
        alt=""
      />
    </div>
    <div class="aBox2">
      <div class="aBox2Content">
        <div class="ab2Main">
          <div class="ab2Left">
            <div class="ab2LTitle">联系我们</div>
            <div class="cBox1">
              <div class="cLine1">
                <div class="cName">工作热线</div>
                <div class="cTxt">18017562278</div>
              </div>
              <div class="cLine2">
                <div class="cName">Email</div>
                <div class="cTxt">liujian@xiyundata.com</div>
              </div>
            </div>
            <div class="cBox2">
              <div class="cLine3">
                <div class="cName">研发中心</div>
                <div class="cTxt">上海市宝山区蕴川路<br>516号泰德科技园A座412</div>
              </div>
              <div class="cLine4">
                <div class="cName">运营总部</div>
                <div class="cTxt">江苏省苏州市相城区高铁新城<br>青龙港路58号天成时代商务广场28层</div>
              </div>
            </div>
          </div>
          <div class="ab2Right">
            <div class="ab2R2">
              <img src="http://cdn.xiyundata.com/crane_index/shugangCode.jpg" class="r2Img" alt="">
              <div class="r2Txt">微信公众号</div>
            </div>
            <div class="ab2R1">
              <img src="http://cdn.xiyundata.com/crane_index/qiyeweixin.jpg" class="r2Img" alt="">
              <div class="r2Txt">企业微信</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script >
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
  
  <style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.cranePage {
  /* padding-top: 70px; */
}
.aBox1 {
  width: 100vw;
}
.ab1Img {
  width: 100%;
}
.ab1Img2 {
  width: 100%;
}
.aBox2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 702px;
}
.aBox2Content {
  display: flex;
  flex-direction: column;
  width: 1200px;
  height: 100%;
  padding-top: 158px;
}
.ab2Top {
  font-size: 34px;
  font-weight: bold;
  color: #262626;
  line-height: 1.3;
  margin-bottom: 6px;
}
.ab2Title {
  font-size: 30px;
  color: #262626;
  line-height: 1.3;
  margin-bottom: 50px;
}
.cBox4Content {
  width: 1200px;
  height: 100%;
}
.c4Line {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.c4TopImg {
  width: 275px;
  height: 140px;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  margin-bottom: 20px;
  overflow: hidden;
}
.c4TopPic {
  width: 275px;
  border-radius: 6px;
  vertical-align: middle;
}

.ab2Main {
  display: flex;
  justify-content: space-between;
}

.ab2Left {
  width: 536px;
}

.ab2Right {
  padding-top: 114px;
  display: flex;
}

.ab2R2 {
  width: 206px;
  margin-right: 80px;
}
.r2Img {
  width: 206px;
  height: 206px;
  margin-bottom: 15px;
}

.r2Txt {
  width: 100%;
  display: flex;
  justify-content: center;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 700;
  font-size: 16px;
  color: #33333A;
  line-height: 23px;
}

.ab2LTitle {
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 700;
  font-size: 30px;
  color: #33333A;
  line-height: 43px;
  margin-bottom: 80px;
}
.cBox1 {
  display: flex;
  width: 530px;
  height: 104px;
  display: flex;
  border-bottom: 1px solid #E8E8E8;
}
.cLine1 {
  margin-right: 168px;
}
.cBox2 {
  display: flex;
  width: 536px;
  height: 124px;
  display: flex;
  align-items: flex-end;
}
.cLine3 {
  margin-right: 90px;
}
.cName {
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 700;
  font-size: 16px;
  color: #33333A;
  line-height: 23px;
  margin-bottom: 12px;
}
.cTxt {
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 16px;
  color: #66666A;
  line-height: 23px;
}

/* 媒体查询，屏幕宽度小于830px */
@media (max-width: 830px) {
  .ab1Img {
    display: none;
  }
  .ab1Img2 {
    display: block;
  }
  .aBox2 {
    height: auto;
  }
  .aBox2Content {
    padding-top: 35px;
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 68px;
  }
  .ab2Main {
    display: block;
  }
  .ab2Left {
    width: 100%;
  }
  .ab2Right {
    width: 100%;
    padding-top: 74px;
    flex-direction: column;
    align-items: center;
  }
  .ab2R2 {
    width: 256px;
    margin-right: 0px;
    margin-bottom: 50px;
  }
  .r2Img {
    width: 256px;
    height: 256px;
    margin-bottom: 20px;
  }
  .ab2Top {
    font-size: 23px;
  }
  .ab2Title {
    font-size: 23px;
  }
  .ab2Content {
    font-size: 12px;
  }
  .aBox2Content {
    width: 100%;
  }
  .cBox4Content {
    width: 76%;
  }
  .aBox2 {
    height: auto;
  }
  .c4TopImg {
    height: 100%;
    flex: 1 1 46%; /* 两个项目，每个项目占据48%宽度 */
    margin-right: 2%; /* 右边距 */
    margin-bottom: 4%; /* 下边距 */
    max-width: 46%; /* 最大宽度限制 */
  }
  .c4TopPic {
    width: 100%;
  }
  .ab2LTitle{
    font-size: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 68px;
  }
  .cBox1 {
    display: block;
    border-bottom: none;
    height: auto;
  }
  .cBox2 {
    display: block;
    height: auto;
  }
  .cLine1 {
    display: flex;
    margin-right: 0px;
    padding-bottom: 26px;
    width: 366px;
    border-bottom: 1px solid #E8E8E8;
  }
  .cLine2{
    display: flex;
    margin-right: 0px;
    padding-bottom: 26px;
    padding-top: 34px;
    width: 366px;
    border-bottom: 1px solid #E8E8E8;
  }
  .cLine3{
    display: flex;
    margin-right: 0px;
    padding-bottom: 26px;
    padding-top: 34px;
    width: 366px;
    border-bottom: 1px solid #E8E8E8;
  }
  .cLine4{
    display: flex;
    margin-right: 0px;
    padding-bottom: 26px;
    padding-top: 34px;
    width: 366px;
  }
  .cName {
    width: 102px;
    margin-right: 0px;
    font-size: 14px;
  }
  .cTxt {
    font-size: 14px;
    width: 260px;
  }
}

@media (min-width: 830px) {
  .ab1Img {
    display: block;
  }
  .ab1Img2 {
    display: none;
  }
  .c4TopImg {
    flex: 1 1 22%; /* 四个项目，每个项目占据22%宽度 */
    margin-right: 2%; /* 右边距 */
    margin-bottom: 2%; /* 下边距 */
    max-width: 22%; /* 最大宽度限制 */
  }
}
</style>
  